export default "__VITE_ASSET__e040d33c__"